import React, { Component } from 'react';
import { Wrapper } from "components";
import styled from "react-emotion";
import Img from 'gatsby-image';
import backgroundImage from '../shared/images/banner_client.png';
import blueTriangle from '../shared/images/triangle_small-blue.png';

const ClientsContainer = styled.div`
    background: url(${blueTriangle}) no-repeat, url(${backgroundImage}) no-repeat;
    background-position: right top, center;
    background-size: 10rem, cover;
    padding-top: 4rem;
    padding-bottom: 4rem;
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        padding-top: 0rem;
        padding-bottom: 2rem;
    }
`;

const StyledClients = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row-reverse;
`;

const ClientHeader = styled.div`
    width: 50%;
    padding-left: 6rem;
    margin-top: 1rem;
    @media (max-width: ${props => props.theme.breakpoints.l}) {
        width: 50%;
    }
    @media (max-width: ${props => props.theme.breakpoints.m}) {
        width: 50%;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        width: 100%;
        padding-left: 0;
    }
`;

const ClientTitle = styled.h1`
    font-size: 1.75rem;
    margin: 0;
    color: ${props => props.theme.colors.darkBlue};
`;

const ClientSubtitle = styled.p`
    font-size: 0.85rem;
`;

const ClientTiles = styled.div`
    width: 50%;
    display: flex;
    flex-wrap: wrap;
    background: ${props => props.theme.colors.white};
    @media (max-width: ${props => props.theme.breakpoints.l}) {
        width: 50%;
    }
    @media (max-width: ${props => props.theme.breakpoints.m}) {
        width: 50%;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        width: 100%;
    }
`;

const StyledClient = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1rem;
    position: relative;
    width: ${100/3}%;
    border-style: solid;
    border-width: 1px;
    border-color: ${props => props.theme.colors.greyLight};
    @media (max-width: ${props => props.theme.breakpoints.l}) {
        width: ${100/3}%;
    }
    @media (max-width: ${props => props.theme.breakpoints.m}) {
        width: ${100/3}%;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        width: 50%;
    }
`;

class Clients extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        const { clients } = this.props;
        // Limit to top 6
        const topClients = clients.slice(0, 6);;
        const clientTiles = topClients.map((client) =>
            <StyledClient key={client.node.uid}>
                <Img fluid={client.node.data.company_logo.localFile.childImageSharp.fluid} />
            </StyledClient>
        );
        return (
            <ClientsContainer>
                <Wrapper>
                    <StyledClients>
                        <ClientHeader>
                            <ClientTitle>Our clients are seeking enterprise solutions</ClientTitle>
                            <ClientSubtitle>Bourne Digital supports them to deliver delightful experiences.</ClientSubtitle>
                        </ClientHeader>
                        <ClientTiles>{clientTiles}</ClientTiles>
                    </StyledClients>
                </Wrapper>
            </ClientsContainer>
        );
    }
}

export default Clients;